import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';
import { SeedingApplyAcceptBodySchema } from './seedingMutationSchemas';

const ApplyRecruitmentCampaignRequestSchema = z
  .object({
    campaignId: z.number().int(),
    body: SeedingApplyAcceptBodySchema,
  })
  .describe('ApplyRecruitmentCampaignRequest');

export type ApplyRecruitmentCampaignRequest = z.infer<typeof ApplyRecruitmentCampaignRequestSchema>;

const ApplyRecruitmentCampaignResponseDataSchema = z
  .object({
    participationId: z.number().int(),
  })
  .describe('ApplyRecruitmentCampaignResponseData');

const ApplyRecruitmentCampaignResponseSchema = createApiResponseSchema(
  ApplyRecruitmentCampaignResponseDataSchema,
);

export type ApplyRecruitmentCampaignResponse = z.infer<
  typeof ApplyRecruitmentCampaignResponseSchema
>;

export const applyRecruitmentCampaign = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(ApplyRecruitmentCampaignRequestSchema),
    async ({
      campaignId,
      body,
    }: ApplyRecruitmentCampaignRequest): Promise<ApplyRecruitmentCampaignResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.post<ApplyRecruitmentCampaignResponse>(
          urlJoin(campaignsApiPath.applyRecruitmentCampaign(campaignId)),
          body,
        ),
      ),
    validateApiResponse(ApplyRecruitmentCampaignResponseSchema),
  ),
);
